module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gmain",
    attrs: {
      "id": "main"
    }
  }, [(_vm.hebSen) ? _c('div', [_c('div', {
    staticClass: "audio-container"
  }, [_c('AudioBtn', {
    attrs: {
      "urlId": _vm.audioSrc,
      "autoplay": _vm.autoPlay && _vm.win,
      "idx": _vm.idx,
      "display": _vm.win
    }
  })], 1), _vm._v(" "), _c('h2', {
    class: {
      flipX: _vm.rightNum === _vm.senLength + 1
    }
  }, [_vm._v("\n      " + _vm._s(_vm.hebSen.words) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ansCon"
  }, [(_vm.rightAnswers) ? _c('div', {
    staticClass: "lines",
    style: ({})
  }, _vm._l((_vm.rightAnswers), function(eword, idx) {
    return _c('div', {
      key: idx,
      staticClass: "eanswer wrap"
    }, [_c('span', {
      staticClass: "ansText"
    }, [_vm._v(_vm._s(eword.words))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "wordsContainer"
  }, _vm._l((_vm.allWords), function(eword, idx) {
    return _c('div', {
      key: idx,
      staticClass: "eword shrink-on-active",
      class: {
        ewordFinish: _vm.rightNum === _vm.senLength + 1,
        ewordSuccess: _vm.rightAnswers.includes(eword),
        ewordNo: _vm.notAnswers.includes(eword),
        ewordFailed: _vm.wrongAnswers.includes(eword)
      },
      on: {
        "click": function($event) {
          return _vm.checkWord(eword, $event)
        }
      }
    }, [_c('EwordBtn', {
      attrs: {
        "word": eword,
        "rightWords": _vm.rightAnswer,
        "autoPlay": _vm.autoPlay
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.win) ? _c('div', {
    staticClass: "actions-wrapper"
  }, [_c('button', {
    staticClass: "winBtn",
    on: {
      "click": _vm.nextGame
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("engGame.eng.continue")) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "safeMargin",
    style: (_vm.safeBottomVar)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0eee59a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EngGame/eng.vue
// module id = 451
// module chunks = 1 4